import { Component, Input, OnInit } from '@angular/core';
import { FinexSidebarService } from './rds-sidebar.service';
import { RouteInfo } from './sidebar.metadata';

@Component({
  selector: 'finex-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class FinexSidebarComponent implements OnInit {

	@Input() hasMiniSidebar: boolean = true;
	@Input() appLogo: string = '';
	@Input() companyLogo: string = '';

	defaultMiniOpts: any = {
		has_apps: true,
		has_setting: true,
		has_help: true
	};
	nav_collapsed: boolean = false;
	menuItems: RouteInfo[] = [];
	showBackButton: boolean = false;
	isLoading : boolean = true;

	loadingTheme:any= {
		'height.px': 40,
		'border-radius': 0,
		'margin-bottom': 0,
		'background-color': '#d8d8d8'
	  };

	constructor(private $sidebar: FinexSidebarService) { }

	ngOnInit(): void {
		this.isLoading = true;
		this.$sidebar.changeMenu.subscribe(sidebar => {
			if (sidebar && sidebar.length) {
				sidebar.forEach(sb => {
					if (!sb.submenu) {
						sb.submenu = [];
					}
				});
				this.menuItems = sidebar;
			}
			this.isLoading = false;
		});
	}

	onEmitName(name: string) {
		this.$sidebar.sideBarEmitter.emit(name);
		this.showBackButton = name ? true : false;
	}

}
